<template>
  <v-content>
    <v-container grid-list-md fluid class="pt-3">
      <slc-alert-dialog>
        <span slot="title">Keine Berechtigung</span>
        <span slot="message"
          >Sie sind derzeit leider nicht berechtigt, dpa-Select zu nutzen. Bitte
          wenden Sie sich an unseren dpa-Kundenservice. Vielen Dank!</span
        >
      </slc-alert-dialog>
    </v-container>
  </v-content>
</template>

<script>
import { defineComponent } from "vue";
import SlcAlertDialog from "@/components/SlcAlertDialog.vue";

export default defineComponent({
  components: { SlcAlertDialog }
});
</script>
